/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class StatusConnections {

        public statusCodeId: string;
        public toStatusGroupIds: Array<string>;

        constructor(processStatusGroup: models.ProcessStatusGroup) {
            this.statusCodeId = processStatusGroup.processStatusGroupDto.id;
            this.toStatusGroupIds = StatusConnections.getToStatusGroupIds(processStatusGroup.workflowBlocks);
        }

        public static createStatusConnectionObjects(processStatusGroups: models.ProcessStatusGroup[]): StatusConnections[] {
            return Enumerable.from(processStatusGroups).select(i => new StatusConnections(i)).toArray();
        }

        public static getToStatusGroupIds(workflowBlocks: models.IWorkflowBlock[]) : Array<string> {
            return Enumerable.from(workflowBlocks)
                .where(i => i.type === Wars.Domain.Model.Codes.Enums.BlockType.StatusChange && (<StatusChangeWorkflowBlock>i).toStatusGroupId != undefined)
                .select(i => (<StatusChangeWorkflowBlock>i).toStatusGroupId)
                .toArray();
        }
    }
}